import React, { Component } from 'react'
import { Field } from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { renderTextField } from '../../Forms/fieldRenderers'
import { renderSelectField } from '../../Forms/fieldRenderers'
import { TextField, FormGroup, FormControlLabel } from '@material-ui/core'

import Switch from '@material-ui/core/Switch'
import moment from 'moment'

import {
  required
} from '../../Forms/fieldValidators'
import Grid from '@material-ui/core/Grid'

const maxLength = max => value =>
  value && value.length > max ? `Debe tener un máximo de ${max} caracteres de largo` : undefined
const number = value => value && isNaN(Number(value)) ? 'Debe ingresar un valor Numérico' : undefined
const maxLength16 = maxLength(16)

class CamposCoemCierreDeCarga extends Component {
  render () {
    const {
      fechaEmbarque,
      changeEmbarque,
      updateCierreCumplido,
      cierreCumplido,
      selectedExportador,
      isRequesting,
      onSelect,
      renderExportadores
    } = this.props
    return (
      <div style={{ paddingLeft: 5, paddingRight: 5 }}>
        <fieldset>
          <legend>Información de registro</legend>
          <Row>
            <Grid container justify='space-around'>
              {/* <Col md={2}>
                <Field
                  name='item'
                  type='text'
                  label='# de Item'
                  component={renderTextField}
                  autoFocus
                  validate={[required, number]}
                  placeholder='1'
                />
              </Col> */}
              <Col md={4}>
                <Field
                  name='identificadorDeclaracion'
                  type='text'
                  label='Destinación/Permiso de Embarque'
                  component={renderTextField}
                  autoFocus={false}
                  validate={[required, maxLength16]}
                  placeholder='23067EC01000074X'
                />
              </Col>
              <Col md={2}>
                <Field
                  name='peso'
                  type='text'
                  label='Total bultos'
                  component={renderTextField}
                  autoFocus={false}
                  validate={[required, number]}
                  placeholder=''
                />
              </Col>
              <Col md={6}>
                <Field
                  onChange={onSelect}
                  name='exportador'
                  label='Exportador'
                  autoFocus={false}
                  component={renderSelectField}
                  value={selectedExportador}
                >
                  {isRequesting ? null : renderExportadores()}
                </Field>
              </Col>
            </Grid>
          </Row>
        </fieldset>
        <fieldset>
          <legend>Detalle de carga</legend>
          <Row>
            <Grid container justify='space-around'>
              <Col md={2}/>
              <Col md={4}>
                <FormGroup name='coem-cierre-de-carga'>
                  <FormControlLabel labelPlacement='rigth' label='Cumplido de Permiso' control={
                    <Switch
                      color='primary'
                      name='cierreCumplido'
                      onChange={updateCierreCumplido}
                      checked={cierreCumplido}
                    />}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <TextField
                  id='datetime-local'
                  label='Finalización de Embarque'
                  name='fechaEmbarque'
                  type='datetime-local'
                  defaultValue={moment(fechaEmbarque).format('YYYY-MM-DD[T]HH:mm') || moment().format('YYYY-MM-DD[T]HH:mm')}
                  onChange={(e) => { changeEmbarque(e) }}
                  helperText=''
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Col>
              <Col md={2}/>
            </Grid>
          </Row>
          <hr />
          <Row>
            <Col md={2}>
              <span><h6>Item #1</h6></span>
            </Col>
            <Col md={2}>
              <Field
                name='cantidadReal'
                type='text'
                label='Peso Embarcado'
                component={renderTextField}
                autoFocus={false}
                validate={[required, number]}
                placeholder='0'
              />
            </Col>
            <Col md={2}/>
            <Col md={2}>
              <span><h6>Item #2</h6></span>
            </Col>
            <Col md={2}>
              <Field
                name='cantidadReal2'
                type='text'
                label='Peso Embarcado'
                component={renderTextField}
                autoFocus={false}
                validate={[number]}
                placeholder='0'
              />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={2}>
              <span><h6>Item #3</h6></span>
            </Col>
            <Col md={2}>
              <Field
                name='cantidadReal3'
                type='text'
                label='Peso Embarcado'
                component={renderTextField}
                autoFocus={false}
                validate={[number]}
                placeholder='0'
              />
            </Col>
            <Col md={2}/>
            <Col md={2}>
              <span><h6>Item #4</h6></span>
            </Col>
            <Col md={2}>
              <Field
                name='cantidadReal4'
                type='text'
                label='Peso Embarcado'
                component={renderTextField}
                autoFocus={false}
                validate={[number]}
                placeholder='0'
              />
            </Col>
          </Row>
        </fieldset>
        <hr />
      </div>
    )
  }
}

export default CamposCoemCierreDeCarga
